module.exports = __webpack_public_path__ + "static/media/send.fd84a4e8.svg";